import React from "react";
import { Link } from "react-router-dom";
import "./notFound.css";
import notFoundImage from "../../assets/404.png";

const NotFound = () => {
  return (
    <div className="menus-page-container">
      <div className="not-found-div">
        <img src={notFoundImage} className="not-found-img" />
        <Link
          className="not-found-link"
          to="#"
          onClick={() => window.history.back()}
        >
          GO BACK
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
